module.exports = __webpack_public_path__ + "static/media/1.fd019891.png";